import FullLayout from '../layouts/Full';

export default function Root() {
    return <FullLayout />;
}
